import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';
import { storedLocale } from 'partners/storedLocale';
import InstaviewLogoMark from 'assets/instaview/logoMark.svg?react';

export const instaviewBaseUrl = `${envConfig(
  'b2BucketUrl'
)}/homeSecurity/instaview`;

export const defaultAssets: TPartnerAssets = {
  logo: `${instaviewBaseUrl}/logo.svg`,
  loginIllustration: `${instaviewBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${instaviewBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${instaviewBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${instaviewBaseUrl}/attention.svg`,
  basicAlertsIcon: `${instaviewBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${instaviewBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${instaviewBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${instaviewBaseUrl}/decriptiveAIAlertsIcon.svg`,
  firmwareVersionIcon: `${instaviewBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${instaviewBaseUrl}/interntNotConnected.svg`,
  limitedSecurityIcon: `${instaviewBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${instaviewBaseUrl}/location.svg`,
  logoContrastIcon: `${instaviewBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${instaviewBaseUrl}/logoWhite.svg`,
  logoMarkIcon: InstaviewLogoMark,
  maxCameraLimitReachedIcon: `${instaviewBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${instaviewBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosIcon: `${instaviewBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${instaviewBaseUrl}/paymentFailedIcon.svg`,
  DownGradeConfirmationIcon: `${instaviewBaseUrl}/DownGradeConfirmation.svg`,
  paymentSuccessfulIcon: `${instaviewBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${instaviewBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${instaviewBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${instaviewBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${instaviewBaseUrl}/professionMonitoringIcons.svg`,
  // professionalMonitoringImg: `${instaviewBaseUrl}/professionalMonitoring.png`,
  sampleCreditCardIcon: `${instaviewBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${instaviewBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${instaviewBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${instaviewBaseUrl}/wifiIcon.svg`,
  appQRCodeAndroid: `${instaviewBaseUrl}/qrCodeAndroid.png`,
  appQRCodeIos: `${instaviewBaseUrl}/qrCodeIos.png`,
  motionAlertsIcon: `${instaviewBaseUrl}/motionAlerts.png`,
  snapshotIcon: `${instaviewBaseUrl}/snapshotIcon.png`,
  liveViewIcon: `${instaviewBaseUrl}/liveViewIcon.png`,
  dataIcon: `${instaviewBaseUrl}/dataIcon.png`,
  noDataIcon: `${instaviewBaseUrl}/noDataIcon.png`,
  autoDataRechargeDisabled: `${instaviewBaseUrl}/autoDataRechargeDisabled.png`,
};

// 2️⃣ Locale-specific overrides
const localeOverrides: Record<string, Partial<TPartnerAssets>> = {
  es: {
    basicMotionAlertsImg: `${instaviewBaseUrl}/basicMotionAlerts-es.png`,
  }
};

// 3️⃣ Merge default with overrides
export const getAssetsForLocale = (locale: string): TPartnerAssets => {
  return {
    ...defaultAssets,
    ...localeOverrides[locale]
  };
};

const locale = storedLocale();

export const assets = getAssetsForLocale(locale || 'en-US');
